<template>
    <div class="container-fluid">
        

        <div class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3 mb-4 px-3 px-md-0">
            <div>
                <h3 class="fw-bold mb-1">Faktury</h3>
                <p class="text-muted small mb-0">Lista faktur jakie zostały wystawione na koncie
                </p>
            </div>
            <button
                class="btn btn-primary-dark d-flex align-items-center justify-content-center gap-2 w-100 btn-responsive-auto"
                @click="openModalForCreate()">
                <i class="bi bi-plus-lg"></i>
                <span>Wystaw fakturę</span>
            </button>
        </div>

        <!-- LISTA FAKTUR -->
        <div class="card border shadow-sm">
            <div class="card-body">                <div class="table-responsive">

                <Vue3EasyDataTable :headers="headers" :items="invoices" :loading="loading" buttons-pagination show-index>
                    <template #item-ksefStatus="{ ksefStatus }">
                        <span v-if="ksefStatus === 'sent'" class="badge bg-success-subtle text-success border border-success-subtle">
                            <i class="bi bi-check-all me-1"></i>Wysłana KSeF
                        </span>
                        <span v-else class="badge bg-secondary-subtle text-secondary border border-secondary-subtle">
                            Niewysłana
                        </span>
                    </template>

                    <template #item-actions="item">
                        <div class="d-flex justify-content-end gap-1 py-1">
                            <!-- Przycisk Edycji (Kredka) -->
                            <button class="btn btn-sm btn-outline-primary" title="Edytuj fakturę" @click="editInvoice(item)">
                                <i class="bi bi-pencil"></i>
                            </button>

                            <!-- Pobierz PDF Faktury -->
                            <button class="btn btn-sm btn-outline-secondary" title="Pobierz Fakturę PDF" @click="downloadPDF(item)">
                                <i class="bi bi-file-earmark-pdf"></i>
                            </button>

                            <!-- Pobierz Polisę OC / Assistance (jeśli URL istnieje) -->
                            <a v-if="item.ocPdfUrl" :href="item.ocPdfUrl" target="_blank" class="btn btn-sm btn-outline-info" title="Pobierz Polisę OC">
                                <i class="bi bi-shield-check"></i>
                            </a>

                            <!-- Pobierz Dokument Gwarancji (jeśli URL istnieje) -->
                            <a v-if="item.warrantyPdfUrl" :href="item.warrantyPdfUrl" target="_blank" class="btn btn-sm btn-outline-warning" title="Pobierz Gwarancję">
                                <i class="bi bi-award"></i>
                            </a>

                            <!-- Usuwanie (Tylko gdy NIE wysłano do KSeF) -->
                            <button class="btn btn-sm btn-outline-danger" title="Usuń" :disabled="item.ksefStatus === 'sent'" @click="deleteInvoice(item.id)">
                                <i class="bi bi-trash"></i>
                            </button>
                        </div>
                    </template>
                </Vue3EasyDataTable></div>
            </div>
        </div>

        <!-- MODAL TWORZENIA FAKTURY -->
        <div ref="invoiceModalRef" class="modal fade" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title fw-bold">Nowa faktura</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>

                    <div class="modal-body p-4">
                        <form @submit.prevent>
                            <InvoiceSection1 v-model="form" :lastInvoices="lastInvoices" @fetchNextDocNumber="fetchNextDocNumber" />

                            <InvoiceSection2 v-model="form.vehicle" :vehicleAddons="vehicleAddons" @openVehicleSelector="openVehicleSelector" @addAddon="addAddonToItems" />

                            <VehicleSelectorModal ref="vehicleSelectorModalRef" @select="onVehicleSelected" />

                            <InvoiceSection2b :vehicle="form.vehicle" :amount="totalInvoiceAmount" @addAddon="addAddonToItems" v-model:selectedAddons="form.selectedAddons" @updateItems="syncAddonsToItems" />

                            <InvoiceSection3 v-model="form.items" :dicts="dicts" @addItem="addItem" @removeItem="removeItem" />

                            <InvoiceSection4 v-model="form.seller" :dicts="dicts" @fetchGus="fetchGusData" />

                            <InvoiceSection5 v-model="form.buyer" :dicts="dicts" @fetchGus="fetchGusData" />

                            <InvoiceSection6 v-model="form.coOwner" :dicts="dicts" />

                            <InvoiceSection7 v-model="form" v-model:sellerModel="form.seller" :dicts="dicts" />

                            <InvoiceSection8 v-model="form.notes" />

                            <InvoiceSection9 v-model="form.additionalInfo" />

                            <InvoiceSection10 v-model="form" />
                        </form>
                    </div>

                    <div class="modal-footer bg-light d-flex justify-content-between">
                        <button type="button" class="btn btn-light" data-bs-dismiss="modal">Anuluj</button>
                        <button type="button" class="btn btn-primary" :disabled="saving" @click="saveInvoice">
                            <i class="bi bi-save me-1"></i>Zapisz
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- MODAL PODSUMOWANIA PO ZAPISIE FAKTURY -->
        <div ref="invoiceSummaryModalRef" class="modal fade" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header bg-light">
                        <h5 class="modal-title fw-bold">
                            <i class="bi bi-check-circle-fill text-success me-2"></i>Faktura została zapisana
                        </h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>

                    <div class="modal-body p-4" v-if="savedInvoiceSummary">
                        <div class="row g-3 mb-4">
                            <div class="col-md-6">
                                <span class="text-muted d-block small">Numer faktury</span>
                                <strong class="fs-5">{{ savedInvoiceSummary.docNumber || '—' }}</strong>
                            </div>
                            <div class="col-md-6 text-md-end">
                                <span class="text-muted d-block small">Nabywca</span>
                                <strong>{{ savedInvoiceSummary.buyerName || savedInvoiceSummary.buyer?.companyName || '—' }}</strong>
                            </div>
                        </div>

                        <hr />

                        <div class="card mb-4 bg-light border">
                            <div class="card-body d-flex justify-content-between align-items-center flex-wrap gap-2">
                                <div>
                                    <h6 class="fw-bold mb-1">Status KSeF</h6>
                                    <span v-if="savedInvoiceSummary.ksefStatus === 'sent'" class="badge bg-success">
                                        <i class="bi bi-check-circle me-1"></i>Wysłana do KSeF
                                    </span>
                                    <span v-else class="badge bg-secondary">
                                        <i class="bi bi-clock me-1"></i>Niewysłana do KSeF
                                    </span>
                                </div>
                                <div>
                                    <button v-if="savedInvoiceSummary.ksefStatus !== 'sent'" type="button" class="btn btn-success d-flex align-items-center gap-1" :disabled="sendingKsef" @click="sendToKsef(savedInvoiceSummary)">
                                        <span v-if="sendingKsef" class="spinner-border spinner-border-sm me-1" role="status"></span>
                                        <i v-else class="bi bi-send"></i>
                                        <span>Wyślij do KSeF</span>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <h6 class="fw-bold mb-3">Pliki do pobrania</h6>
                        <div class="d-flex flex-column gap-2">
                            <button type="button" class="btn btn-outline-primary text-start d-flex justify-content-between align-items-center" @click="downloadPDF(savedInvoiceSummary)">
                                <span><i class="bi bi-file-earmark-pdf me-2"></i>Pobierz Fakturę VAT (PDF)</span>
                                <i class="bi bi-download"></i>
                            </button>

                            <a v-if="savedInvoiceSummary.ocPdfUrl" :href="savedInvoiceSummary.ocPdfUrl" target="_blank" class="btn btn-outline-secondary text-start d-flex justify-content-between align-items-center">
                                <span><i class="bi bi-shield-check me-2"></i>Pobierz Polisę OC (PDF)</span>
                                <i class="bi bi-download"></i>
                            </a>

                            <a v-if="savedInvoiceSummary.warrantyPdfUrl" :href="savedInvoiceSummary.warrantyPdfUrl" target="_blank" class="btn btn-outline-secondary text-start d-flex justify-content-between align-items-center">
                                <span><i class="bi bi-award me-2"></i>Pobierz Dokument Gwarancji (PDF)</span>
                                <i class="bi bi-download"></i>
                            </a>
                        </div>
                    </div>

                    <div class="modal-footer bg-light">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Zamknij</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- UKRYTY SZABLON HTML DO GENEROWANIA PDF -->
        <div style="display: none;">
            <InvoiceTemplate ref="invoicePdfRenderArea" v-if="pdfInvoiceDetails" :invoice="pdfInvoiceDetails" />
        </div>

        <AppLoader :show="saving || loading || sendingKsef" :text="loaderText" />
    </div>
</template>

<script setup>
import { ref, reactive, onMounted, computed, nextTick } from 'vue'
import { useRoute } from 'vue-router'
import apiClient from '@/api'
import Modal from 'bootstrap/js/dist/modal'
import html2pdf from 'html2pdf.js'
import Vue3EasyDataTable from 'vue3-easy-data-table'
import 'vue3-easy-data-table/dist/style.css'
import AppLoader from '@/components/AppLoader.vue'
import { webAlert, showConfirm } from '@/utils/dialog'
import InvoiceSection1 from '../components/invoices/InvoiceSection1.vue'
import InvoiceSection2 from '../components/invoices/InvoiceSection2.vue'
import InvoiceSection2b from '../components/invoices/InvoiceSection2b.vue'
import InvoiceSection3 from '../components/invoices/InvoiceSection3.vue'
import InvoiceSection4 from '../components/invoices/InvoiceSection4.vue'
import InvoiceSection5 from '../components/invoices/InvoiceSection5.vue'
import InvoiceSection6 from '../components/invoices/InvoiceSection6.vue'
import InvoiceSection7 from '../components/invoices/InvoiceSection7.vue'
import InvoiceSection8 from '../components/invoices/InvoiceSection8.vue'
import InvoiceSection9 from '../components/invoices/InvoiceSection9.vue'
import InvoiceSection10 from '../components/invoices/InvoiceSection10.vue'
import VehicleSelectorModal from '../components/invoices/VehicleSelectorModal.vue'
import InvoiceTemplate from '@/components/templates/InvoiceTemplate.vue'

const pdfInvoiceDetails = ref(null)
const invoicePdfRenderArea = ref(null)
const route = useRoute()

const loading = ref(false)
const saving = ref(false)
const sendingKsef = ref(false)
const loaderText = ref('')

const invoices = ref([])
const lastInvoices = ref([])
const vehicleAddons = ref([])
const savedInvoiceSummary = ref(null)

const invoiceModalRef = ref(null)
const invoiceSummaryModalRef = ref(null)

let invoiceModalInstance = null
let invoiceSummaryModalInstance = null
const vehicleSelectorModalRef = ref(null)

const headers = [
    { text: 'Numer faktury', value: 'docNumber', sortable: true },
    { text: 'Odbiorca', value: 'buyerName', sortable: true },
    { text: 'Kwota netto', value: 'totalNet', sortable: true },
    { text: 'Kwota brutto', value: 'totalGross', sortable: true },
    { text: 'Status KSeF', value: 'ksefStatus', sortable: true },
    { text: 'Akcje', value: 'actions', width: 180 }
]

const onVehicleSelected = async (vehicleData) => {
    Object.assign(form.vehicle, {
        id: vehicleData.id,
        make: vehicleData.make || '',
        model: vehicleData.model || '',
        engineCapacity: vehicleData.engineCapacity || '',
        mileage: vehicleData.mileage || '',
        gearbox: vehicleData.gearbox || '',
        fuelType: vehicleData.fuelType || '',
        powerHp: vehicleData.powerHp || '',
        color: vehicleData.color || '',
        type: vehicleData.type || 'osobowy',
        vin: vehicleData.vin || '',
        registrationPlate: vehicleData.registrationPlate || '',
        productionYear: vehicleData.productionYear || '',
        firstRegistrationDate: vehicleData.firstRegistrationDate || '',
        additionalInfo: vehicleData.additionalInfo || ''
    })

    if (vehicleData.price && form.items.length > 0) {
        const priceGross = Number(vehicleData.price)
        const vatRate = 0

        form.items[0].name = `Sprzedaż pojazdu ${vehicleData.make} ${vehicleData.model} (VIN: ${vehicleData.vin || ''})`
        form.items[0].vatRate = vatRate
        form.items[0].priceGross = priceGross
        form.items[0].priceNet = Number((priceGross / (1 + vatRate / 100)).toFixed(2))
    }
}

const syncAddonsToItems = ({ warranty, oc }) => {
    form.items = form.items.filter(item => !item.isAddon)

    
    if (warranty) {
        //const title = `Gwarancja CarGwarant ${warranty.packetName || warranty.packet} (${warranty.okresMiesiecy} mies.)`
        //const priceGross = Number(warranty.cena) || 0
        //const vatRate = 23
        //const priceNet = Number((priceGross / (1 + vatRate / 100)).toFixed(2))

        /*form.items.push({
            name: title,
            unit: 'szt.',
            gtu: '',
            quantity: 1,
            priceNet: priceNet,
            vatRate: vatRate,
            priceGross: priceGross,
            isAddon: true,
            addonType: 'warranty'
        })
            */
    }

    if (oc) {
        //const priceGross = Number(oc.cena) || 0
        //const vatRate = 0
        //const priceNet = Number((priceGross / (1 + vatRate / 100)).toFixed(2))

        /*form.items.push({
            name: 'Ubezpieczenie OC / Assistance',
            unit: 'szt.',
            gtu: '',
            quantity: 1,
            priceNet: priceNet,
            vatRate: vatRate,
            priceGross: priceGross,
            isAddon: true,
            addonType: 'oc'
        })
        */
    }
        
}

const editInvoice = async (item) => {
    saving.value = true
    loaderText.value = 'Pobieranie danych faktury do edycji...'
    
    try {
        const response = await apiClient.post({ 
            action: 'get-invoice', 
            id: item.ID
        })

        const rawData = response.data?.data?.[0] || response.data?.data || response.data

        console.log('Otrzymane dane faktury do edycji:', rawData)

        if (rawData) {
            // 1. Resetujemy formularz do stanu pustego
            Object.assign(form, createEmptyForm())

            // 2. Mapujemy główne pola nagłówka faktury
            form.id = rawData.ID
            form.docNumber = rawData.invoiceNumber || ''
            form.issueDate = rawData.createDate || new Date().toISOString().substring(0, 10)
            form.saleDate = rawData.sellDate ? rawData.sellDate.replace(' ', 'T') : new Date().toISOString().substring(0, 16)
            form.issuePlace = rawData.city || ''
            form.bdo = rawData.bdo || ''
            form.invoiceType = rawData.typeOfDocument || ''
            form.isVariantOption = rawData.wariantDokumentu === 'yes'
            form.isMarginProcedure = rawData.proceduraMarzy === 'yes'
            form.currency = rawData.currency || 'PLN'
            form.notes = rawData.additional_info || ''

            // 3. Mapowanie osób (seller, buyer, coOwner) z tablice "persons"
            if (Array.isArray(rawData.persons)) {
                rawData.persons.forEach(p => {
                    if (p.role === 'seller' && form.seller) {
                        Object.assign(form.seller, p)
                    } else if (p.role === 'buyer' && form.buyer) {
                        Object.assign(form.buyer, p)
                    } else if (p.role === 'coOwner' && form.coOwner) {
                        Object.assign(form.coOwner, p)
                    }
                })
            }

            // 4. Mapowanie wielu płatności z tablicy "payment"
            if (Array.isArray(rawData.payment) && rawData.payment.length > 0) {
                form.payments = rawData.payment.map(pay => ({
                    amount: pay.amount || 0,
                    paymentType: pay.paymentType || 'Przelew',
                    dueDate: pay.dueDate && pay.dueDate !== '0000-00-00' ? pay.dueDate : '',
                    currency: pay.currency || 'PLN',
                    vatExemptReason: pay.vatExemptReason || '',
                    vatExemptDescription: pay.vatExemptDescription || '',
                    bankName: pay.bankName || '',
                    bankAccount: pay.bankAccount || ''
                }))
            }

            // 5. Pobieranie danych auta na podstawie carID, jeśli istnieje i jest różne od "0"
            const carId = rawData.car?.carID

            if (carId && carId !== "0" && carId !== 0 && !rawData.car?.make && !rawData.car?.vin) {
                loaderText.value = 'Pobieranie danych pojazdu...'
                try {
                    const carResponse = await apiClient.post(
                        { action: 'get-car-details', ID: carId }
                    )

                    const car = carResponse.data?.data?.[0] || carResponse.data?.data || carResponse.data

                    if (car) {
                        onVehicleSelected({
                            id: car.ID || car.id,
                            make: car.make || '',
                            model: car.model || '',
                            engineCapacity: car.engineCCM || car.engineCapacity || '',
                            mileage: car.mileage || '',
                            gearbox: car.gearboxTXT || '',
                            fuelType: car.fuelTXT || '',
                            powerHp: car.powerKM || car.powerHp || '',
                            color: car.colourTXT || car.color || '',
                            vin: car.VIN || car.vin || '',
                            registrationPlate: car.registerNumber || car.registrationPlate || '',
                            productionYear: car.productionYear || '',
                            firstRegistrationDate: car.firstRegistrationDate || '',
                            price: car.price || 0,
                            additionalInfo: car.offerDesc || ''
                        })
                    }
                } catch (carError) {
                    console.error('Błąd podczas pobierania szczegółów pojazdu:', carError)
                }
            } else {
                onVehicleSelected({
                            id: rawData.car?.ID || rawData.car?.id || rawData.car?.carID,
                            make: rawData.car?.make || '',
                            model: rawData.car?.model || '',
                            engineCapacity: rawData.car?.engineCCM || rawData.car?.engineCapacity || '',
                            mileage: rawData.car?.mileage || '',
                            gearbox: rawData.car?.gearbox || '',
                            fuelType: rawData.car?.fuelType || '',
                            powerHp: rawData.car?.powerKM || rawData.car?.powerHp || '',
                            color: rawData.car?.colourTXT || rawData.car?.color || '',
                            vin: rawData.car?.VIN || rawData.car?.vin || '',
                            registrationPlate: rawData.car?.registerNumber || rawData.car?.registrationPlate || '',
                            productionYear: rawData.car?.productionYear || '',
                            firstRegistrationDate: rawData.car?.firstRegistrationDate || '',
                            price: rawData.car?.price || 0,
                            additionalInfo: rawData.car?.offerDesc || ''
                })
            }
        }

        // Otwarcie modala z załadowanymi danymi
        invoiceModalInstance.show()

    } catch (error) {
        console.error('Błąd podczas pobierania faktury do edycji:', error)
        webAlert('Nie udało się pobrać danych faktury.')
    } finally {
        saving.value = false
    }
}

const openVehicleSelector = () => {
    vehicleSelectorModalRef.value?.show()
}
 
const dicts = reactive({
    vatRates: [],
    countries: [],
    paymentStatuses: [],
    paymentTypes: [],
    currencies: [],
    vatExemptReasons: []
})

const fetchDict = async (action, extraData = {}) => {
    try {
        const res = await apiClient.post({ action, ...extraData })
        return Array.isArray(res.data?.data) ? res.data.data : []
    } catch { return [] }
}

const loadDictionaries = async () => {
    dicts.vatRates = await fetchDict('get-vat-rates')
    dicts.countries = await fetchDict('get-countries')
    dicts.paymentStatuses = await fetchDict('get-payment-statuses')
    dicts.paymentTypes = await fetchDict('get-payment-types')
    dicts.currencies = await fetchDict('get-currencies')
    dicts.vatExemptReasons = await fetchDict('get-vat-exceptions')
}

const createEmptyParty = () => ({
    nip: '', companyName: '', firstName: '', lastName: '', country: 'Polska',
    postalCode: '', city: '', street: '', email: '', phone: '', pesel: '',
    idCardSeriesNumber: '', notes: '', bankName: '', bankAccount: ''
})

const totalInvoiceAmount = computed(() => form.items[0]?.priceGross || 0)

const createEmptyForm = () => ({
    id: null,
    invoiceType: '',
    docNumber: '',
    issueDate: new Date().toISOString().substring(0, 10),
    saleDate: new Date().toISOString().substring(0, 16),
    issuePlace: '',
    bdo: '',
    isVariantOption: false,
    isMarginProcedure: false,
    vehicle: {
        id: null, make: '', model: '', engineCapacity: '', mileage: '', gearbox: '',
        fuelType: '', powerHp: '', color: '', vin: '', registrationPlate: '',
        productionYear: '', firstRegistrationDate: '', additionalInfo: ''
    },
    items: [
        { name: '', unit: 'szt.', gtu: '', quantity: 1, priceNet: 0, vatRate: 23, priceGross: 0 }
    ],
    // Jawny reset płatności do jednego domyślnego wiersza przy czyszczeniu formularza:
    payments: [
        {
            amount: 0,
            paymentType: 'Przelew',
            dueDate: '',
            currency: 'PLN',
            vatExemptReason: '',
            vatExemptDescription: '',
            bankName: '',
            bankAccount: ''
        }
    ],
    seller: createEmptyParty(),
    buyer: createEmptyParty(),
    coOwner: createEmptyParty(),
    paymentStatus: 'Niezapłacono',
    paymentType: 'Przelew',
    dueDate: '',
    currency: 'PLN',
    vatExemptReason: '',
    vatExemptDescription: '',
    notes: '',
    additionalInfo: '',
    issuerName: '',
    receiverName: '',
    selectedAddons: {
        warranty: null,
        oc: null
    },
})

const form = reactive(createEmptyForm())

const loadInvoices = async () => {
    loading.value = true
    try {
        const response = await apiClient.post({ action: 'get-invoices' })
        invoices.value = response.data?.data || []
    } catch (e) {
        console.error('Błąd podczas pobierania faktur:', e)
        webAlert('Błąd podczas pobierania faktur.')
    } finally {
        loading.value = false
    }
}

// Pobieranie listy trzech ostatnich faktur
const fetchLastInvoices = async () => {
    try {
        const response = await apiClient.post({ action: 'get-last-invoices' })
        const rawData = response.data?.data || response.data || []
        
        // Mapujemy obiekty tak, aby wyciągnąć sam docNumber (i opcjonalnie data)
        lastInvoices.value = rawData.map(item => {
            if (typeof item === 'object' && item !== null) {
                return {
                    docNumber: item.docNumber,
                    createDate: item.createDate
                }
            }
            return { docNumber: item, createDate: '' }
        })
    } catch (error) {
        console.error('Błąd pobierania ostatnich faktur:', error)
        lastInvoices.value = []
    }
}

const fetchNextDocNumber = async () => {
    if (!form.saleDate) return

    try {
        const response = await apiClient.post(
            { action: 'get-next-invoice-number', saleDate: form.saleDate },
        )

        if (response.data) {
            if (response.data.number) form.docNumber = response.data.number
            if (!form.issuePlace && response.data.city) form.issuePlace = response.data.city
            if (!form.bdo && response.data.bdo) form.bdo = response.data.bdo
        }
    } catch (error) {
        console.error('Błąd pobierania kolejnego numeru faktury:', error)
    }
}

const addItem = () => {
    form.items.push({ name: '', unit: 'szt.', gtu: '', quantity: 1, priceNet: 0, vatRate: 23, priceGross: 0 })
}

const removeItem = (idx) => {
    form.items.splice(idx, 1)
}

const addAddonToItems = (addon) => {
    form.items.push({
        name: addon.title,
        unit: 'szt.',
        gtu: '',
        quantity: 1,
        priceNet: addon.priceNet,
        vatRate: 23,
        priceGross: Number((addon.priceNet * 1.23).toFixed(2))
    })
}

const fetchGusData = async (type) => {
    const target = form[type]
    if (!target.nip) return
    saving.value = true
    loaderText.value = 'Pobieranie z GUS...'
    try {
        const res = await apiClient.post({ action: 'get_data_from_gus', nip: target.nip })
        if (res.data?.success) {
            Object.assign(target, res.data.company)
            if (type === 'seller') {
                form.issuePlace = target.city
                form.bdo = target.bdo || ''
            }
        }
    } finally {
        saving.value = false
    }
}

const openModalForCreate = () => {
    Object.assign(form, createEmptyForm())
    vehicleAddons.value = []
    fetchLastInvoices() // Pobierz 3 ostatnie faktury
    invoiceModalInstance.show()
}

const openSummaryModal = (invoiceData) => {
    savedInvoiceSummary.value = invoiceData
    invoiceSummaryModalInstance.show()
}

const downloadPDF = async (item) => {
    saving.value = true
    loaderText.value = 'Pobieranie danych faktury i generowanie PDF...'
    try {
        const response = await apiClient.post({ action: 'get-invoice', id: item.ID || item.id })
        const data = response.data?.data?.[0] || response.data?.data || response.data

        if (!data) {
            webAlert('Nie udało się odnaleźć danych wybranej faktury.')
            return
        }

        pdfInvoiceDetails.value = data
        await nextTick()

        const opt = {
            margin: 5,
            filename: `Faktura_${data.docNumber || item.ID}.pdf`,
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2, useCORS: true },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
        }

        const element = invoicePdfRenderArea.value?.$el || invoicePdfRenderArea.value?.element
        
        if (!element) {
            webAlert('Nie odnaleziono elementu DOM do wygenerowania PDF.')
            return
        }

        const pdfWorker = html2pdf().set(opt).from(element)
        const pdfBlob = await pdfWorker.output('blob')

        const blobUrl = URL.createObjectURL(pdfBlob)
        window.open(blobUrl, '_blank')

    } catch (error) {
        console.error('Błąd generowania PDF:', error)
        webAlert('Błąd podczas generowania pliku PDF faktury.')
    } finally {
        saving.value = false
    }
}

const saveInvoice = async () => {
    saving.value = true
    loaderText.value = 'Zapisywanie faktury...'
    try {
        const response = await apiClient.post(
            { action: 'save-invoice', invoice: form }
        )

        const resData = response.data

        if (resData?.status === 'success' || resData?.type === 'success' || resData?.success) {
            invoiceModalInstance.hide()
            await loadInvoices()

            const invoiceResult = {
                ...form,
                ...(resData.data || {}),
                ocPdfUrl: resData.ocPdfUrl || resData.data?.ocPdfUrl || null,
                warrantyPdfUrl: resData.warrantyPdfUrl || resData.data?.warrantyPdfUrl || null
            }

            openSummaryModal(invoiceResult)
        } else {
            saving.value = false
            webAlert(resData || 'Błąd podczas zapisywania faktury.')
        }
    } catch (e) {
        console.error('Błąd zapisu faktury:', e)
        saving.value = false
        webAlert('Wystąpił błąd podczas połączenia z serwerem.')
    } finally {
        saving.value = false
    }
}

const sendToKsef = async (invoice) => {
    const confirmed = await showConfirm(
        'Czy na pewno chcesz wysłać tę fakturę do KSeF?\nTej czynności NIE DA SIĘ COFNĄĆ!',
        { title: 'Ostrzeżenie - KSeF' }
    )
    if (!confirmed) return

    sendingKsef.value = true
    loaderText.value = 'Wysyłanie do KSeF...'
    try {
        const response = await apiClient.post(
            { action: 'send-to-ksef', invoiceId: invoice.id || invoice.docNumber }
        )

        if (response.data?.status === 'success' || response.data?.success) {
            savedInvoiceSummary.value.ksefStatus = 'sent'
            await loadInvoices()
            webAlert(response.data)
        } else {
            webAlert(response.data)
        }
    } catch (e) {
        console.error('Błąd KSeF:', e)
        webAlert('Błąd połączenia podczas wysyłki do KSeF.')
    } finally {
        sendingKsef.value = false
    }
}

const deleteInvoice = async (id) => {
    const confirmed = await showConfirm('Czy na pewno chcesz usunąć tę fakturę?')
    if (!confirmed) return

    saving.value = true
    try {
        await apiClient.post(
            { action: 'delete-invoice', id }
        )
        await loadInvoices()
    } finally {
        saving.value = false
    }
}

onMounted(async () => {
    await loadDictionaries()

    invoiceModalInstance = new Modal(invoiceModalRef.value)
    invoiceSummaryModalInstance = new Modal(invoiceSummaryModalRef.value)
    await loadInvoices()

    if (route.query?.vehicleId) {
        const vehicleId = route.query.vehicleId

        openModalForCreate()
        saving.value = true
        loaderText.value = 'Pobieranie danych pojazdu...'

        try {
            const response = await apiClient.post(
                { action: 'get-car-details', ID: vehicleId }
            )

            const car = response.data?.data?.[0] || response.data?.data || response.data

            if (car) {
                onVehicleSelected({
                    id: car.ID || car.id,
                    make: car.make || '',
                    model: car.model || '',
                    engineCapacity: car.engineCCM || car.engineCapacity || '',
                    mileage: car.mileage || '',
                    gearbox: car.gearboxTXT || '',
                    fuelType: car.fuelTXT || '',
                    powerHp: car.powerKM || car.powerHp || '',
                    color: car.colourTXT || car.color || '',
                    vin: car.VIN || car.vin || '',
                    registrationPlate: car.registerNumber || car.registrationPlate || '',
                    productionYear: car.productionYear || '',
                    firstRegistrationDate: car.firstRegistrationDate || '',
                    price: car.price || 0,
                    additionalInfo: car.offerDesc || ''
                })
            }
        } catch (error) {
            saving.value = false
            console.error('Błąd podczas pobierania szczegółów pojazdu do faktury:', error)
            webAlert('Nie udało się automatycznie pobrać pełnych danych pojazdu.')
        } finally {
            saving.value = false
        }
    }
})
</script>

<style scoped>
.cursor-pointer {
    cursor: pointer;
    user-select: none;
}
</style>